import { render, staticRenderFns } from "./createPriceDialog.vue?vue&type=template&id=01f3de42&scoped=true"
import script from "./createPriceDialog.vue?vue&type=script&lang=js"
export * from "./createPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./createPriceDialog.vue?vue&type=style&index=0&id=01f3de42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3de42",
  null
  
)

export default component.exports